import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;
    if (!session_id) {
      toast.error("Missing session id from Google");
      nav("/auth", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        localStorage.setItem("umg_token", data.token);
        await refresh();
        toast.success(data.new_user ? `Welcome to Umaang, ${data.user.name}` : `Welcome back, ${data.user.name}`);
        // Strip fragment before navigating
        window.history.replaceState(null, "", window.location.pathname);
        nav(data.user.role === "admin" ? "/admin" : (data.new_user ? "/profile/edit" : "/home"), { replace: true });
      } catch (e) {
        toast.error(formatError(e));
        nav("/auth", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="google-callback">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#C85A53]" />
        <div className="mt-4 text-sm text-[color:var(--umg-text-2)]">Completing Google sign-in…</div>
      </div>
    </div>
  );
}
